import React, { ReactNode } from 'react';
import { animated } from 'react-spring';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';

import { useStore } from '@vromo/mobx-react';
import { RootStore } from '@vromo/dashboard/src/stores/RootStore';




export const Desktop = styled.div`
    @media (max-width: 1000px) {
        display: none !important;
    }
`;

const Tabs = styled.div`
    display: flex;
    flex: 1;

    @media (max-width: 1000px) {
        display: ${props => (props.active ? 'flex' : 'none')} !important;
        max-width: none;
    }
`;

const AnimatedTabs = animated(Tabs);

type TabViewProps = {
    tab: string;
    children: ReactNode;
    className?: any;
    style?: any;
}

export const TabView = observer<TabViewProps>(({ tab, children, className, style }) => {

    const { viewStore } = useStore<RootStore>('rootStore');

    return (
        <AnimatedTabs
            active={viewStore.tab === tab}
            className={className}
            style={style}
        >
            {children}
        </AnimatedTabs>
    );
});
